import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { CommonNotificationService } from 'src/app/shared/services/common-notification/common-notification.service';

@Injectable()
export class AuthenticationService {
  token = {
    refresh_token: 'refreshtokencode',
    exp: new Date((new Date().getDate() + 1)),
    access_token: {
      username: 'user'
      // roles: ['Admin', 'RegisteredUser', 'Super User']
    }
  };

  tokenKey = 'a6smm_utoken';

  constructor(private router: Router, private httpClient: HttpClient,
    private commonNotificationService: CommonNotificationService,) {
    this.clearLocalStorage = this.clearLocalStorage.bind(this);
  }

  login(username, password) {
    this.setToken(this.token);
    // this.router.navigate(['design-components']);
    window.location.pathname = '/';
  }

  _login(username, password) {
    const _this = this;
    const params = new FormData();
    params.append('company_email', username);
    params.append('company_password', password);
    params.append('dashboard_version', '3.0');
    return this.httpClient.post('../dashboard/login', params)
      .subscribe(
        (response: any) => {
          if (response.is_error) {
            if (response.error_type === 'DASHBOARD_REDIRECT_ERROR') {
              const r = window.confirm('We notice that your Netcore Product Experience account resides on https://dashboard.hansel.io. You will now be redirected to continue with login.');
              if (r === true) {
                window.location.href = 'https://dashboard.hansel.io';
              }
            } else {
              this.commonNotificationService.showSnackBar(response.error_message, 'error');
            }
            return;
          }
          const _token = _this.token.access_token.username = username;
          this.setToken(_this.token);
          // this.router.navigate(['actions']);
          window.location.pathname = '/';
        },
        error => {
          this.commonNotificationService.showSnackBar("Invalid credentials provided", 'error');
        });
  }

  inviteUser(payload, cb) {
    payload.dashboard_version = '3.0';
    return this.httpClient.put('../dashboard/confirmuserinvite', payload)
      .subscribe(
        (response: any) => {
          if (response.is_error) {
            this.commonNotificationService.showSnackBar(response.error_message, 'error');
            return;
          }
          return cb(response);
          // this.router.navigate(['login']);
        },
        error => {
        });
  }

  createUser(payload, cb, plan?) {
    payload.dashboard_version = '3.0';
    const params = new FormData();
    // tslint:disable-next-line:forin
    for (const prop in payload) {
      params.append(prop, payload[prop]);
    }

    let url = '../dashboard/createaccount';
    if (plan && plan === 'self-serve') {
      url = '../dashboard/user_onboarding/createaccount';
    }


    return this.httpClient.post(url, params)
      .subscribe(
        (response: any) => {
          if (response.is_error) {
            this.commonNotificationService.showSnackBar(response.error_message, 'error');
            return;
          }
          return cb(response);
          // this.router.navigate(['login']);
          // alert('Thank you for registering with us! Now Login');
        },
        error => {
        });
  }

  sendActivationLink(payload, cb) {
    const params = new FormData();
    // tslint:disable-next-line:forin
    for (const prop in payload) {
      params.append(prop, payload[prop]);
    }

    return this.httpClient.post('../dashboard/generatepasswordrequest', params)
      .subscribe(
        (response: any) => {
          if (response.is_error) {
            this.commonNotificationService.showSnackBar(response.error_message, 'error');
            return;
          }
          return cb(response);
        },
        error => {
        });
  }

  resetPassword(payload, cb) {
    const params = new FormData();
    // tslint:disable-next-line:forin
    for (const prop in payload) {
      params.append(prop, payload[prop]);
    }

    return this.httpClient.post('../dashboard/updatepassword', params)
      .subscribe(
        (response: any) => {
          if (response.is_error) {
            this.commonNotificationService.showSnackBar(response.error_message, 'error');
            return;
          }
          return cb(response);
        },
        error => {
        });
  }

  logout(cb?) {
    return this.httpClient.get('../dashboard/logout')
      .subscribe(
        (response: any) => {
          if (response.is_error) {
            this.commonNotificationService.showSnackBar(response.error_message, 'error');
            return;
          }
          this.clearLocalStorage();
          if (this.isIframe()) {
            window.location.pathname = '/auth/ce-authenticate';
            return;
          }
          window.location.pathname = '/auth';
          if (cb) {
            return cb(response);
          }
        },
        error => {
        });
  }

  clearLocalStorage = () => {
    const lsKeys = Object.keys(localStorage);
    const keysToBeRemoved = lsKeys.filter(key => !(key.match(/_appListByUsage$/g) || key.match(/_selectedApp$/g)));
    keysToBeRemoved.forEach(key => localStorage.removeItem(key));
  }

  getToken() {
    return JSON.parse(localStorage.getItem(this.tokenKey));
  }

  setToken(token) {
    localStorage.setItem(this.tokenKey, JSON.stringify(token));
  }

  getAccessToken() {
    return JSON.parse(localStorage.getItem(this.tokenKey))['access_token'];
  }

  isAuthenticated() {
    const isTokenAvailable = localStorage.getItem(this.tokenKey) ? true : false;
    return isTokenAvailable;
  }

  refreshToken() {
    this.token.exp = new Date((new Date().getDate() + 1));
    this.setToken(this.token);
  }

  removeToken() {
    localStorage.removeItem(this.tokenKey);
  }

  fetchCEPanelDetail(params?) {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.httpClient.post<any>("/dashboard/getsmtapiresponse", params, httpOptions).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  ssoLogin(username) {
    const params = new FormData();
    params.append("company_email", username);
    return this.httpClient.post("../dashboard/ssologin", params);
  }

  fetchSSOStatus() {
    return this.httpClient.get("../dashboard/getstatus");
  }

  fetchSSOUserStatus(status = false) {
    return this.fetchSSOStatus().subscribe(
      (response: any) => {
        if (response.is_error) {
          this.commonNotificationService.showSnackBar(
            response.error_message,
            "error"
          );
          setTimeout(() => {
            this.logout();
          }, 2000)
        } else {
          if (!status) {
            this.commonNotificationService.showSnackBar(
              "SSO user login successful",
              "success"
            );
            window.location.pathname = "/";
          }
        }
      },
      (error) => {
        this.commonNotificationService.showSnackBar(
          error,
          "error"
        );
      }
    );
  }

  verifyEmailLink(data) {
    const params = new FormData();
    params.append("company_name", data.company_name);
    params.append("email", data.email);
    params.append("hash", data.hash);
    return this.httpClient.post("../dashboard/verifyEmailLink", params);
  }

  getLocalStorageKey(key) {
    return JSON.parse(localStorage.getItem(key));
  }

  setLocalStorageKey(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  removeLocalStorageKey(key) {
    localStorage.removeItem(key)
  }

  authenticateCE(payload) {
    return this.httpClient.post('dashboard/ce/authenticate', payload);
  }

  cePostMessage(msg) {
    window.parent.postMessage(msg, "*");
  }

  isIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }
}
